
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer_service",
      function () {
        return require("private-next-pages/customer_service/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer_service"])
      });
    }
  